<template>
  <div class="reports-container">
    <ReportDetails ref="report-details-modal"></ReportDetails>
    <b-form class="w-100 h-100 p-3 d-flex flex-column">
      <b-form-group id="input-group-1" label="Tipo de Reporte:" label-for="typeReport" label-align="start" class="mb-2">
        <div class="d-flex flex-row align-items-center">
          <b-form-select id="typeReport" v-model="report.type" :options="typeReports" required class="d-flex form-select w-auto"></b-form-select>
          <svg class="settings ms-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80z" />
          </svg>
        </div>
      </b-form-group>
      <b-form-group id="input-group-2" label="Unidad:" label-for="device" label-align="start" class="mb-2">
        <div class="d-flex flex-row">
          <img :src="require(`@/assets/img/devices/${report.device.icon}.png`)" style="height: 35px" class="me-2" />
          <b-form-select @change="changeSelection" selected="true" id="device" v-model="report.device.id" :options="options" required class="d-flex form-select w-auto"></b-form-select>
        </div>
      </b-form-group>
      <DateSelector ref="dateSelector" v-keep-scroll-position></DateSelector>
      <b-form-group label="Desde:" label-for="desde" label-align="start" class="mb-2">
        <div class="d-flex flex-row">
          <b-form-input v-model="report.from.date" id="report-from-date" class="date text-center" readonly @change="changeDate"></b-form-input>
          <b-form-input v-model="report.from.hour" id="report-from-hour" class="hour ms-2 text-center" type="time"></b-form-input>
        </div>
      </b-form-group>
      <b-form-group label="Hasta:" label-for="desde" label-align="start" class="mb-3">
        <div class="d-flex flex-row">
          <b-form-input v-model="report.to.date" id="report-to-date" class="date text-center" readonly @change="changeDate"></b-form-input>
          <b-form-input v-model="report.to.hour" id="report-to-hour" class="hour ms-2 text-center" type="time"></b-form-input>
        </div>
      </b-form-group>
      <div class="form-check d-flex">
        <input class="form-check-input" type="checkbox" id="showGuides" v-model="report.showGuides" @change="setShowGuides" />
        <label class="form-check-label ms-1" for="showGuides">Mostrar Guías de Recorrido</label>
      </div>
      <div class="d-flex flex-row justify-content-center align-items-center w-100 mt-3">
        <div @click="execReport" class="action d-flex flex-row align-items-center justify-content-center px-3 py-2 text-light rounded fs-5 mx-1">
          <img class="me-1" src="@/assets/img/execute.svg" />
          <p class="m-0">Ejecutar</p>
        </div>
        <div v-if="showDetails" @click="getDetails" class="action d-flex flex-row align-items-center justify-content-center px-3 py-2 text-light rounded fs-5 mx-1">
          <img src="@/assets/img/route-detail.svg" />
        </div>
      </div>
    </b-form>
  </div>
</template>

<script lang="ts">
import PositionService from '@/api/services/position.service'
import ReverseGeocoderService from '@/api/services/reverse-geocoder.service'
import DateSelector from '@/components/DateSelector.vue'
import ReportDetails from '@/components/modals/ReportDetails.vue'
import PositionDto from '@/models/dto/position.dto'
import { ReportType } from '@/models/enum-types/report-type.enum'
import PikadayService from '@/services/pikaday.service'
import devicesModule from '@/store/modules/devices.module'
import globalModule from '@/store/modules/global.module'
import reportsModule from '@/store/modules/reports.module'
import ReportStrategyFactory from '@/strategies/report.strategy/report.strategy.factory'
import DateUtil from '@/utils/date.util'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {
    DateSelector,
    ReportDetails
  },
})
export default class Reports extends Vue {
  get options() {
    return devicesModule.optionsDevices
  }

  stops: any[] = [{ text: '3 Min', value: '3' }].concat(this.getStops(' Min', 5, 60))

  typeReports: any[] = Object.values(ReportType).map((item) => {
    return { text: item, value: item }
  })

  report = {
    showGuides: true,
    device: {
      id: 0,
      icon: '0'
    },
    from: {
      date: dayjs().locale('es').format('DD/MM/YYYY'),
      hour: '00:00',
    },
    to: {
      date: dayjs().locale('es').format('DD/MM/YYYY'),
      hour: '23:59',
    },
    type: ReportType.CONSOLIDATED_REPORT,
  }

  mounted() {
    this.report.showGuides = reportsModule.report.showGuides
    reportsModule.setFromPicker(
      PikadayService.create('report-from-date', dayjs().toDate())
    )
    reportsModule.setToPicker(
      PikadayService.create('report-to-date', dayjs().toDate())
    )
    globalModule.updateBodySize()

    console.log('mounted reports')
  }

  @Watch("options", { immediate: true })
  onChangeDevices(): void {
    if (this.report.device.id == 0) {
      this.report.device.id = devicesModule.devices[0]?.id || 0
      this.report.device.icon = devicesModule.devices[0]?.icon || '0'
    }
  }

  changeSelection() {
    this.report.device.icon =
      devicesModule.devices.find((item) => item.id == this.report.device.id)?.icon ||
      '0'
  }

  changeDate() {
    const dateSelectorRef: any = this.$refs.dateSelector!
    this.report.from.date == this.report.to.date
      ? dateSelectorRef.selection = this.report.from.date
      : dateSelectorRef.selection = ''
  }

  getStops(suffix: string, from: number, to: number) {
    let array: { text: string, value: string }[] = []
    for (let i = from; i <= to; i = i + 5) {
      array.push({ text: i + suffix, value: i.toString() })
    }
    return array
  }

  async execReport() {
    const data = await this.getReportData();
    const device = await devicesModule.getDevicebyId(this.report.device.id)
    if (data.length === 0) {
      alert("No se encontraron posiciones")
    } else {
      console.log(this.report)
      await ReportStrategyFactory.create(this.report, data, device!).process()
      globalModule.setRaster(false)
    }
  }

  async getDetails() {
    globalModule.reportLoader.visible = true
    const data = await this.getReportData();
    const device = await devicesModule.getDevicebyId(this.report.device.id)
    const modal: any = this.$refs['report-details-modal']
    modal.plate = device?.name
    modal.icon = device?.icon
    modal.from = `${this.report.from.hour} ${this.report.from.date}`
    modal.to = `${this.report.to.hour} ${this.report.to.date}`
    modal.data = []
    if (data.length == 0) {
      alert("No se encontraron posiciones")
    } else {
      modal.show()
      const dataWithAddress = []
      await Promise.all(
        data.map(async (item) => {
          item.address = item.address || (await ReverseGeocoderService.getAddress(item.latitude, item.longitude)).data.display_name
          dataWithAddress.push(item);
        })
      );
      console.log(data)
      modal.data = data;
      modal.device = device;
    }
    globalModule.reportLoader.visible = false
  }

  async getReportData() {
    const from = DateUtil.formatDateForGetReport(this.report.from.date + this.report.from.hour)
    const to = DateUtil.formatDateForGetReport(this.report.to.date + this.report.to.hour)
    const data: PositionDto[] = (await PositionService.getPositionsByDevice(this.report.device.id, from, to)).data
    return data
  }

  setShowGuides() {
    reportsModule.setShowGuides(this.report.showGuides)
  }

  get showDetails() {
    return globalModule.user?.attributes?.services?.reportDetails
  }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables.sass'
.settings
  fill: $primary
  transition: all 0.1s ease
  cursor: pointer
  &:active
   transform: scale(0.95)
svg
  height: 25px !important
  fill: $primary
.hour
  max-width: 100px
.date
  max-width: 180px
.action
  background: $primary
  cursor: pointer
  &:active
    transition: all .1s ease
    transform: scale(0.95)
  img
    height: 30px
</style>
